import { Typography } from "PFComponents/typography";
import { CustomValue } from "PFTypes";
import React from "react";
import { useTranslation } from "react-i18next";

import { Section } from "./components/section";
import css from "./skills_management_side_panel.module.scss";

type DescriptionSectionProps = {
  skill: CustomValue;
};

export const DescriptionSection = ({ skill }: DescriptionSectionProps): JSX.Element | null => {
  const { t } = useTranslation("skillsManagement", { keyPrefix: "sidePanel" });
  const { description, globalDescription, value } = skill;

  const descriptionToDisplay = description || globalDescription;
  if (!descriptionToDisplay) {
    return null;
  }

  const skillName = String(value);
  const indexOfSkillNameInDescription = descriptionToDisplay.toLowerCase().indexOf(skillName.toLowerCase());

  return (
    <Section>
      <Typography variant="h4" noMargin>
        {t("description")}
      </Typography>
      <Typography variant="bodyRegular" className={css.description}>
        {indexOfSkillNameInDescription !== -1 ? (
          <>
            {descriptionToDisplay.slice(0, indexOfSkillNameInDescription)}
            <Typography variant="bodyBold" tag="span">
              {skillName}
            </Typography>
            {descriptionToDisplay.slice(indexOfSkillNameInDescription + skillName.length)}
          </>
        ) : (
          <>{descriptionToDisplay}</>
        )}
      </Typography>
    </Section>
  );
};
